/**
 * Банер «Доступна нова версія» (UX-31): глобальний банер оболонки з пріоритетом `version` — нижче
 * за «немає зв'язку», вище за оголошення й пропозицію легкого режиму. Логіка — `platform/version.ts`.
 * Перехід на інший екран — ще одна нагода перевірити (не частіше раз на годину).
 */
import { useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';
import { shell as t } from '../i18n/uk/shell.ts';
import { applyVersion, checkVersion, snoozeVersion, useNewVersion } from '../platform/version.ts';
import { Banner, GLOBAL_BANNER } from '../ui/notify/index.ts';

export function VersionBanner() {
  const pathname = useLocation({ select: (l) => l.pathname });
  const { visible, updating } = useNewVersion();
  // biome-ignore lint/correctness/useExhaustiveDependencies: перевіряємо саме на новому екрані
  useEffect(() => {
    void checkVersion();
  }, [pathname]);
  return (
    <Banner
      area="global"
      priority={GLOBAL_BANNER.version}
      when={visible}
      icon="refresh"
      className="banner--global"
      testId="banner-version"
      bannerKey="new-version"
      actions={
        <>
          <button
            className="btn btn--sm btn--primary"
            type="button"
            aria-busy={updating || undefined}
            disabled={updating}
            onClick={() => void applyVersion()}
          >
            {updating ? t.versionUpdating : t.versionUpdate}
          </button>
          <button className="btn btn--sm" type="button" disabled={updating} onClick={snoozeVersion}>
            {t.versionLater}
          </button>
        </>
      }
    >
      <span>{t.versionAvailable}</span>
    </Banner>
  );
}
